import React from "react";
import Link from "next/link";

export default function Logo() {
  return (
    <div className="flex items-center justify-center">
      <Link
        href="/"
        className="ml-1 text-secondary text-20 font-bold flex items-center cursor-pointer"
      >
        <img src="/images/logo.svg" alt="Logo" />
      </Link>
    </div>
  );
}
